export const AV_APP_ID = 'auditviewer';
